/* eslint-disable no-lonely-if */
/* eslint-disable handle-callback-err */
'use strict';

angular.module('app')
  .controller('CheckoutLA', function ($scope, $routeParams, $uibModal, $window, $timeout,
    SeoService, GTM, DiveOperator, currentDO,
    info, paymentService, $location, $rootScope,
    localStorageService, checkoutService, utils, Auth, gettextCatalog, diviacLocalStorage) {
    var vm = this,
      checkoutIsSubmitted = false,
      cabinPrice = 0,
      selectedCabins = [],
      products = false,
      savedStepTwoCabins = [];

    vm.setLimit = checkoutService.setLimit;
    vm.applyVoucher = applyVoucher;
    vm.removeVoucher = removeVoucher;
    vm.showCouponForm = false;
    vm.pageParams = { location: $routeParams.location, slug: $routeParams.slug };
    vm.slug = $routeParams.slug;


    vm.rentalEquipmentId = utils.getInclusionGroupsId('Rental equipment');
    vm.coursesGroupId = utils.getInclusionGroupsId('LiveaboardCourses');
    vm.divingInclusionsId = utils.getInclusionGroupsId('DC Extras & Surcharge');
    vm.countryList = info.countryList;
    vm.freeCancellation = moment().add(4, 'd').format();

    vm.abTest2 = localStorageService.get('checkoutTest2');

    vm.selectedInclusions = [];

    vm.showPaymentForm = false;
    // vm.paymentType = null;
    vm.experimentId = window.google_optimize && window.google_optimize.get(info.experimentIdLa);
    vm.experimentIsActive = vm.experimentId === '1';
    vm.usdTotalPrice = '';
    vm.paymentProcessor = diviacLocalStorage.get('paymentProcessor') || paymentService.STRIPE_PP;
    vm.isLastMinute = true;

    if (!_.isBoolean(vm.abTest2)) {
      vm.abTest2 = utils.randomRange(1, 2) === 1;

      localStorageService.set('checkoutTest2', vm.abTest2);
    }

    GTM.variables({'user_experiment_1': vm.abTest2 ? 'Cabin CTA: Select Cabin' : 'Cabin CTA: Select'});


    window.onpopstate = function () {
      if (vm.step === 1 || vm.step === 4) {
        history.back();
        window.onpopstate = undefined;
      } else if (vm.step === 5 || vm.step === 'payment-issue') {
        vm.step = 1;

        if (!vm.trips) {
          vm.setFirstStep();
        }
      } else {
        vm.step = vm.step - 1 || 1;

        history.pushState('back', null, null);

        onStepChange();
      }

      $scope.$apply();
    };


    vm.clearFilters = function () {
      vm.loader = true;

      vm.liveaboardFilter.duration = [];
      vm.liveaboardFilter.itinerary = [];
      vm.liveaboardFilter.price = [];
      vm.liveaboardFilter.is_promotion = null;
      vm.from = null;

      _.each(vm.itineraries, function (val) {
        val.checked = false;
      });

      _.each(vm.info.itinerariesLength, function (val) {
        val.checked = false;
      });

      _.each(vm.priceFilter, function (val) {
        val.checked = false;
      });

      getTrips(vm.liveaboardFilter).then(function () {
        vm.loader = false;
      });
    };

    /**
            checkCabin() - function that we use to generate cabins objects with correct cabin occupancy on step 3.
            For detailed information move to this function;
        **/
    var gaClientId;

    if (window.ga) {
      window.ga(function (tracker) {
        gaClientId = tracker.get('clientId');
      });
    }

    vm.order = paymentService.prefillUser();
    vm.step = 1;
    vm.utils = utils;
    vm.itineraries = [];
    vm.liveaboardFilter = {};
    vm.info = currentDO;
    vm.info.gender = info.account.GENDER;
    vm.duration = _.clone(vm.info.itinerariesLength);
    vm.getUserAccount = paymentService.getUserAccount;
    vm.getAffiliate = paymentService.getAffiliate;
    vm.getAffiliateCompaign = paymentService.getAffiliateCompaign;
    vm.setUserAccount = setUserAccount;

    vm.findQty = findQty;
    vm.disableOccupancy = disableOccupancy;
    vm.calculatePrice = calculatePrice;
    vm.calculatePercent = calculatePercent;
    vm.setFirstStep = setFirstStep;
    vm.clearCart = clearCart;
    vm.updateShared = updateShared;
    vm.updateRoom = updateRoom;
    vm.isAffiliate = Auth.isAffiliate();
    vm.checkRequired = checkoutService.checkRequired;
    vm.haveSharedRooms = haveSharedRooms;
    vm.addInclusions = addInclusions;
    vm.pageUrl = utils.createURL('la_page', $routeParams);
    $scope.operator = {
      info: vm.info,
      pageURL: vm.pageUrl,
    };

    vm.selectTrip = selectTrip;
    vm.selectedTrip = [];
    vm.getInclusions = getInclusions;
    vm.addProduct = addProduct;
    vm.totalPrice = getTotalPrice;
    vm.getSelectedProducts = getSelectedProducts;
    vm.setSelectedItem = setSelectedItem;
    vm.checkProducts = checkProducts;
    vm.checkout = checkout;
    vm.error = {};
    vm.reg = {};

    vm.order.shopId = vm.info.id;
    vm.allReviews = [];
    vm.createAccount = createAccount;
    vm.priceFilter = [];
    vm.cardLength = 19;
    vm.saveStepTwo = saveStepTwo;
    vm.saveOrder = saveOrder;
    vm.insurances = [];

    vm.steps = [
      {
        text: gettextCatalog.getString('Select your trip'),
        shortText: gettextCatalog.getString('Trip'),
      },
      {
        text: gettextCatalog.getString('Select your cabin'),
        shortText: gettextCatalog.getString('Cabin'),
      },
      {
        text: gettextCatalog.getString('Add extras'),
        shortText: gettextCatalog.getString('Extras'),
      },
      {
        text: gettextCatalog.getString('Review & book'),
        shortText: gettextCatalog.getString('Review'),
      }
    ];
    vm.isNewOption = sessionStorage.getItem('newOption');
    vm.stepChanged = stepChanged;

    SeoService.generateMetaTags(gettextCatalog.getString('Checkout - Liveaboard - {{ shopTitle }} | PADI Travel', { shopTitle: vm.info.title }));

    _.each(info.liveaboardSearchPriceFilter, function (val, key) {
      vm.priceFilter.push({id: key, from: val.from, to: val.to});
    });


    if (localStorageService.get('order_uuid') && localStorageService.get('referrer') && !vm.isNewOption) {
      vm.orderEdit = true;
      vm.order.referrer = localStorageService.get('referrer');
      vm.order.uuid = localStorageService.get('order_uuid');
    }

    if (vm.info.includeFreeDiveInsurance) {
      // we don't have paid insurances right now, need's to be changed later
      checkoutService.getInsurances().then(function (data) {
        vm.insurances = data;
      });
    }

    DiveOperator.reviews('liveaboard').then(function (rating) {
      vm.reviews = rating;

      _.map(rating.data.results, function (val) {
        vm.allReviews.push(val);
      });
    });

    vm.getMoreReviews = function () {
      vm.reviewsLoading = true;
      DiveOperator.reviews('liveaboard', vm.reviews.data.next).then(function (rating) {
        vm.reviews = rating;

        _.map(rating.data.results, function (val) {
          vm.allReviews.push(val);
        });
        vm.reviews.data.results = vm.allReviews;
        vm.reviewsLoading = false;
      });
    };

    var tripId = $location.search().productId,
      affiliate = utils.getAffiliateId();

    GTM.variables({
      business_id: vm.info.id,
      business_slug: $routeParams.slug,
      business_area_id: vm.info.areaId,
      business_area_name: vm.info.area,
      business_country_id: vm.info.countryId,
      business_country_name: vm.info.country,
      business_country_slug: vm.info.countrySlug,
      business_last_edit_at: vm.info.businessLastEditAt,
      business_type: vm.info.kindVerbose,
      checkout_order_amount: $rootScope.setValue(+vm.info.minimalPrice, vm.info.currency, true, 'USD'),
    });

    if (tripId && !$rootScope.order) {
      vm.loader = true;

      selectTrip(tripId);
    } else if (!$rootScope.order && !tripId) {
      vm.loader = true;
      getTrips().then(function () {
        vm.loader = false;
        var products = [];

        _.each(vm.allTrips, function (val) {
          products.push({
            variant: val.itinerary.title,
            id: vm.info.id,
            price: $rootScope.setValue(+val.price, vm.info.currency, true, 'USD'),
            name: vm.info.title,
            category: 'Liveaboard',
            quantity: 1,
          });
        });

        GTM.products('checkout_step_trip', {
          checkout: {
            actionField: {
              step: 'Trip',
            },
            products: products,
          },
        });
      });
    } else if ($rootScope.order && $rootScope.orderCabins && vm.info.id === $rootScope.order.shopId) {
      vm.order = $rootScope.order;
      angular.extend(vm.order, paymentService.prefillUser());
      vm.cabins = $rootScope.orderCabins;
      vm.selectedTrip = $rootScope.selectedTrip;
      vm.groupedCart = $rootScope.groupedCabins;

      getSelectedProducts();
      checkProducts($rootScope.groupedCabins);

      $rootScope.order = null;
      $rootScope.orderCart = null;
      $rootScope.selectedTrip = null;
    }

    function setFirstStep() {
      if (vm.allTrips) {
        vm.step = 1;

        return true;
      }
      vm.loader = true;

      getTrips().then(function (data) {
        vm.loader = false;
        vm.step = 1;
        vm.allTrips = data;
      });
    }

    function selectTrip(id, e) {
      // overriding ng-href;
      if (e) e.preventDefault();

      vm.step = 2;

      vm.loader = true;

      $location.search({
        productId: +id,
      });

      DiveOperator.getCabins(+id).then(function (data) {
        vm.order.cabinPrice = cabinPrice = 0;
        vm.selectedTrip[0] = data;
        vm.cabins = data.packages;
        vm.cabinsObj = data.packages;

        _.each(vm.cabins, function (val) {
          val.currency = vm.selectedTrip[0].currency;

          if (vm.selectedTrip[0].availability === 0) {
            val.itemAvailability = 0;
          }
        });

        GTM.variables({
          checkout_order_amount: $rootScope.setValue(+data.price, vm.info.currency, true, 'USD'),
        });

        vm.order.from = vm.selectedTrip[0].startDate;
        vm.order.to = vm.selectedTrip[0].endDate;

        vm.loader = false;

        var cartPrice = $rootScope.setValue(+vm.selectedTrip[0].price, vm.info.currency, true, 'USD');

        GTM.variables({'checkout_cart_value': cartPrice});

        GTM.products('checkout_step_cabin', {
          currencyCode: vm.info.currency,
          add: {
            'products': [{
              variant: vm.selectedTrip[0].title,
              id: vm.info.id,
              price: cartPrice,
              brand: vm.info.fleetTitle || 'Independent',
              name: vm.info.title,
              category: 'Liveaboard',
              quantity: 1,
            }],
          },
        });
      });
    }

    function findQty() {
      if (!vm.cabins || vm.cabins && vm.cabins.length === 0) {
        return false;
      }

      return getSelectedProducts().length;
    }

    function getSelectedProducts() {
      products = [];


      _.each(vm.cabins, function (val) {
        _.each(val.prices, function (v) {
          if (v.qty && v.qty > 0) {
            v.currency = currentDO.currency;
            v.roomId = val.roomCategory.id;
            v.roomTitle = val.roomCategory.title;
            v.title = val.roomCategory.title + ' / ' + v.verbose + ' / ' + (v.isDiver ? 'Diver' : 'Non-diver');
            v.images = val.roomCategory.images;
            products.push(v);
          }
        });
      });

      return products;
    }


    function getTrips() {
      return DiveOperator.getTrips({month: 'Show all', startDate: vm.from || null}, vm.liveaboardFilter).then(function (data) {
        var groupedProducts = {},
          trips = data.trips,
          i = 1;

        _.each(trips, function (trip) {
          var month = moment(trip.startDate).month(),
            year = moment(trip.startDate).year();

          trip.iterator = i;
          if (!groupedProducts[year + '_' + month]) {
            groupedProducts[year + '_' + month] = [];
          }
          i++;
          groupedProducts[year + '_' + month].push(trip);
        });

        if (trips.length) {
          $timeout(function () {
            if (window.fbq) {
              window.fbq('track', 'ViewContent', {
                content_ids: [vm.info.id],
                content_type: 'product',
                value: vm.info.minimalPrice,
                currency: vm.info.currency,
              });
            }
          }, 4000);
        }

        vm.trips = groupedProducts;
        vm.allTrips = trips;

        if (!vm.itineraries.length) {
          vm.itineraries = _.uniq(trips, 'itinerary.id');

          if ($location.search().itinerary) {
            vm.liveaboardFilter = {
              'itinerary': [+$location.search().itinerary],
            };

            _.each(vm.itineraries, function (val) {
              if (val.itinerary.id === +$location.search().itinerary) {
                val.itinerary.checked = true;
              }
            });

            $location.search({
              itinerary: null,
            });

            getTrips();
          }
        }

        return true;
      });
    }

    function setSelectedItem(item, type) {
      if (!_.isArray(vm.liveaboardFilter[type]) && type && type !== 'is_promotion') {
        vm.liveaboardFilter[type] = [];
      } else if (type === 'is_promotion') {
        vm.liveaboardFilter[type] = !vm.liveaboardFilter[type];
      }

      if (item) {
        var id = _.isObject(item) ? item.id : item;
        // generateFilterList(item, type);

        if (_.includes(vm.liveaboardFilter[type], id) && type != 'is_promotion' ) {
          vm.liveaboardFilter[type] = _.without(vm.liveaboardFilter[type], id);
          item.checked = false;
        } else if (item) {
          item.checked = true;
          vm.liveaboardFilter[type].push(id);
        }
      }

      vm.liveaboardFilter.page = 1;

      getTrips(vm.filterDate, null, vm.liveaboardFilter);
    }

    function checkout(form) {
      if (vm.selectedTrip && vm.selectedTrip.length && form.$valid) {
        checkoutService.getTripRequirements(vm.selectedTrip[0].itinerary && vm.selectedTrip[0].itinerary.id)
          .then(function (data) {
            vm.requirements = data;
          });
      }

      if (vm.orderEdit) {
        setStaffOrder();

        vm.loader = true;
        return checkoutService.staffUpdate(vm.order).then(function (data) {
          localStorageService.remove('order_uuid');
          localStorageService.remove('referrer');

          if (data.isPaymentsEdited || data.isSupplierPaymentsEdited) {
            vm.isPaymentsEdited = data.isPaymentsEdited;
            vm.isSupplierPaymentsEdited = data.isSupplierPaymentsEdited;
            vm.step = 'payment-issue';

            return vm.step;
          }

          $window.location.href = vm.order.referrer;
        })
          .catch(function (error) {
            if (error.data.nonFieldErrors) {
              $rootScope.showNotify(error.data.nonFieldErrors[0]);
            } else {
              $rootScope.showNotify(gettextCatalog.getString('Something went wrong'));
            }
          })
          .finally(function () {
            vm.loader = false;
          });
      }

      form.$submitted = true;

      if (form.$invalid || (!vm.order.accepted && Auth.isAffiliate())) {
        return false;
      }

      if (form.$valid && (vm.order.accepted || vm.orderEdit ) ) {
        vm.loader = true;

        if (vm.showPaymentForm || vm.experimentIsActive) {
          // bradcasting createSource event to isolated payment directive;
          // payment validation happen there;
          // callback will be saveOrder() function;
          $rootScope.$broadcast('createSource');
        } else {
          saveOrder({source: false});
        }
      }
    }

    function saveOrder(response) {
      var errorMessage = $('.error-msg');

      if (response.noMethod) {
        if (Auth.isStaff() || Auth.isAffiliate()) {
          // payment info is optional for staff so pass them through if they haven't touched payment form;
          saveOrder({source: false});
          return;
        }
        // otherwise force user to choose payment method;
        $rootScope.showNotify(gettextCatalog.getString('You must select a payment method to proceed.'));
        $rootScope.scrollTo('#payment');
        vm.loader = false;
        return;
      } else if (response.error || response.errorCode) {
        vm.loader = false;
        errorMessage.text(response.error.message);
        errorMessage.addClass('visible');
        $rootScope.scrollTo('.payment-methods-list');
        return;
      }

      // add payment response to order
      if (vm.showPaymentForm || vm.experimentIsActive) {
        if (vm.paymentProcessor === paymentService.STRIPE_PP) {
          vm.order.stripeSourceId = response.source ? response.source.id : undefined;
        } else if (vm.paymentProcessor === paymentService.ADYEN_PP) {
          vm.order.adyenPaymentData = response || undefined;
        }
        vm.order.paymentProcessor = vm.paymentProcessor;

        // for redirect payment types we just store payment type for user;
        if (response.isRedirect) {
          delete vm.order.paymentProcessor;
          vm.order.redirectPaymentMethodType = response.paymentMethodValue;
        }
      }

      if (Auth.isStaff() || Auth.isAffiliate()) {
        // Staff order

        setStaffOrder();
        vm.loader = true;

        if (vm.isNewOption && Auth.isStaff()) {
          vm.order.parentOrderReference = vm.isNewOption;
          vm.order.isTeamOption = true;

          sessionStorage.removeItem('newOption');
        }

        checkoutService.staffCheckout(vm.order).then(function (data) {
          setGTMData(data);
          setPageAfterCheckout(data);
        })
          .catch(function (error) {
            vm.success = false;
            vm.loader = false;
            if (error.data.nonFieldErrors) {
              $rootScope.showNotify(error.data.nonFieldErrors[0]);
              errorMessage.text(error.data.nonFieldErrors[0]);
              errorMessage.addClass('visible');
            } else {
              $rootScope.showNotify(gettextCatalog.getString('Something went wrong'));
            }
          });
      } else {
        $rootScope.scrollTo('.complete-wrap');

        if (!checkoutIsSubmitted) {
          var data = {
            shop: vm.info.id,
            items: vm.order.items.concat(vm.addedInclusions),
          };

          data.cart = vm.groupedCart;

          _.each(data.cart, function (v) {
            _.each(v.pricing, function (val) {
              data.items.push({
                pricing: val.id,
                quantity: val.qty,
              });
            });
          });

          angular.extend(vm.order, data);
          vm.order.dateTo = vm.order.to;
          vm.order.dateFrom = vm.order.from;
          vm.order.source = utils.getSource();
          vm.order.userCurrency = $rootScope.currency;

          if (affiliate) {
            vm.order.affiliateId = affiliate.aid;
            vm.order.affiliateCampaign = affiliate.cid;
          }

          if (!vm.showPaymentForm && vm.experimentId) {
            vm.order.gaExperiment = vm.experimentId;
            vm.order.gaClientId = gaClientId;
          }

          checkoutIsSubmitted = true;
        }

        checkoutService.checkout(vm.order).then(function (checkoutData) {
          setGTMData(checkoutData);
          vm.orderId = checkoutData.id;
          vm.order.card = null;

          vm.order.reference = checkoutData.reference;

          $rootScope.scrollTo('.checkout-page');

          setPageAfterCheckout(data);
        }).catch(function (error) {
          vm.success = false;
          vm.loader = false;
          if (error.data.nonFieldErrors) {
            $rootScope.showNotify(error.data.nonFieldErrors[0]);
            errorMessage.text(error.data.nonFieldErrors[0]);
            errorMessage.addClass('visible');
          } else {
            $rootScope.showNotify(gettextCatalog.getString('Something went wrong'));
          }
        });
      }
    }

    function setGTMData(checkoutData) {
      var gtmProducts = [],
        facebookData = {
          content_ids: [vm.info.id],
          content_type: 'product',
          currency: vm.info.currency,
          value: 0,
        };

      _.each(vm.groupedCart, function (v) {
        _.each(v.pricing, function (val) {
          gtmProducts.push({
            name: vm.info.title,
            variant: vm.selectedTrip[0].itinerary.title,
            id: vm.info.id,
            price: $rootScope.setValue(+val.priceNet, vm.info.currency, true, 'USD'),
            brand: vm.info.fleetTitle || 'Independent',
            category: 'Liveaboard',
            quantity: val.qty,
          });

          facebookData.value += val.priceNet;
        });
      });

      vm.usdTotalPrice = $rootScope.setValue(+checkoutData.amountTotal, vm.info.currency, true, 'USD');

      GTM.variables({
        checkout_order_id: checkoutData.reference,
        user_email_md5: utils.md5(vm.order.email),
        checkout_order_amount: vm.usdTotalPrice,
      });

      GTM.products('checkout_complete', {
        'purchase': {
          'actionField': {
            'id': checkoutData.reference,
            'affiliation': checkoutData.affiliateId ? 'Affiliate: ' + checkoutData.affiliateId : 'Diviac',
            'revenue': vm.usdTotalPrice,
          },
          products: gtmProducts,
        },
      });

      if (window.fbq) {
        window.fbq('track', 'Purchase', facebookData);
      }
    }

    function getInclusions() {
      vm.loader = true;
      cabinPrice = 0;
      var diversNumber = 0,
        nonDiversNumber = 0,
        maximumCabinPrice = 0;

      vm.diverCoursesList = [];
      vm.nonDiverCoursesList = [];

      vm.order.roomParams = [];

      _.each(selectedCabins, function (cabin) {
        _.each(cabin.pricing, function (pricingItem) {
          cabinPrice += pricingItem.priceNet * pricingItem.qty;
          if (pricingItem.isDiver) {
            diversNumber += pricingItem.qty;
          } else {
            nonDiversNumber += pricingItem.qty;
          }

          if (pricingItem.priceNet > maximumCabinPrice) {
            maximumCabinPrice = pricingItem.priceNet;
          }
        });
      });

      updateInsurances(maximumCabinPrice);

      vm.diversNumber = Array.apply(null, Array(diversNumber)).map(function (x, i) {
        return {
          key: i + 1,
        };
      });

      vm.nonDiversNumber = Array.apply(null, Array(nonDiversNumber)).map(function (x, i) {
        return {
          key: i + 1,
        };
      });

      checkoutService.getInclusions({
        itinerary: vm.selectedTrip[0].itinerary && vm.selectedTrip[0].itinerary.slug,
        diversNumber: diversNumber,
        nonDiversNumber: nonDiversNumber,
        trip: vm.selectedTrip[0],
      }, {
        date_0: moment(vm.selectedTrip[0].startDate).format('YYYY-MM-DD'),
        date_1: moment(vm.selectedTrip[0].endDate).format('YYYY-MM-DD'),
      }).then(function (data) {
        vm.step = 3;
        vm.inclusions = data.groupedInclusions;
        vm.liveaboardInclusions = {};

        vm.sectionWithoutMandatory = {};

        _.each(vm.inclusions, function (val, key) {
          vm.sectionWithoutMandatory[key] = _.filter(val, function (v) {
            return !v.isMandatory && !v.isIncluded;
          });

          if (vm.rentalEquipmentId !== +key && vm.coursesGroupId !== +key && vm.divingInclusionsId !== +key) {
            var belongsToObject = _.find(info.inclusionGroups, { id: +key });

            if (belongsToObject) {
              vm.liveaboardInclusions[key] =  {
                title: belongsToObject.title,
                order: belongsToObject.order,
                isTransfer: belongsToObject.unique_identifier === 'Transfers',
                key: key,
                data: val,
              };
            }
          }
        });

        _.each(data.inclusions, function (incl) {
          if (vm.coursesGroupId === +incl.belongsTo) {
            if (incl.isNondiverInclusion) {
              vm.nonDiverCoursesList.push(incl);
            } else {
              vm.diverCoursesList.push(incl);
            }
          }
        });
        vm.loader = false;

        var cartPrice = $rootScope.setValue(+vm.selectedTrip[0].price, vm.info.currency, true, 'USD');

        GTM.products('checkout_step_extra', {
          actionField: {
            step: 'Extras',
          },
          products: [{
            variant: vm.selectedTrip[0].title,
            id: vm.info.id,
            price: cartPrice,
            brand: vm.info.fleetTitle || 'Independent',
            name: vm.info.title,
            category: 'Liveaboard',
            quantity: 1,
          }],
        });
      });
    }

    function checkProducts(cart, scrollTarget) {
      var data = {
          shop: vm.info.id,
          items: [].concat(vm.addedInclusions),
          roomParams: {
            divers: 0,
            nonDivers: 0,
            details: [],
          },
        },
        gtmProducts = [];

      data.cart = cart || selectedCabins || checkCabin();

      if (data.cart.length === 0) {
        return true;
      }

      vm.freeInsurance = false;
      vm.totalNumberOfGuests = 0;
      vm.numberOfDivers = 0;
      vm.numberOfNonDivers = 0;

      vm.totalCabinPrices = 0;

      _.each(data.cart, function (v) {
        var cabinObject = {
          roomId: v.room.roomCategory.id,
          divers: 0,
          nonDivers: 0,
        };

        v.cabinPrice = 0;
        v.cabinComparePrice = 0;

        _.each(v.pricing, function (val) {
          data.items.push({
            pricing: val.id,
            quantity: val.qty,
          });

          v.cabinPrice += val.priceNet * val.qty;
          v.cabinComparePrice += val.compareAtPrice * val.qty;

          if (val.isDiver) {
            data.roomParams.divers += val.qty;
            cabinObject.divers += val.qty;
            vm.numberOfDivers += val.qty;
          } else {
            data.roomParams.nonDivers += val.qty;
            cabinObject.nonDivers += val.qty;
            vm.numberOfNonDivers += val.qty;
          }
          vm.totalNumberOfGuests += val.qty;
          if (vm.insurances.length) {
            vm.freeInsurance = $rootScope.setValue(val.priceNet, vm.info.currency, true, vm.insurances[0].limitPriceCurrency) > +vm.insurances[0].limitPrice;
          }

          gtmProducts.push({
            name: vm.info.title,
            id: vm.info.id,
            price: $rootScope.setValue(+val.priceNet, vm.info.currency, true, 'USD'),
            brand: vm.info.fleetTitle || 'Independent',
            variant: vm.selectedTrip[0].title,
            category: 'Liveaboard',
            quantity: val.qty,
          });
        });

        vm.totalCabinPrices += v.cabinPrice;
        data.roomParams.details.push(cabinObject);
      });

      vm.groupedProducts = data.cart;
      vm.order.roomParams = data.roomParams;

      data.dateTo = moment(vm.order.to).format('YYYY-MM-DDThh:mm');
      data.dateFrom = moment(vm.order.from).format('YYYY-MM-DDThh:mm');
      data.isConfirmed = true;
      data.paymentProvider = vm.paymentProcessor;
      vm.loader = true;

      // apply coupon on due
      if (vm.appliedVoucher) {
        data.discountCoupon = vm.appliedVoucher.id;
      } else {
        data.discountCoupon = undefined;
      }

      checkoutService.getDue(data).then(function (res) {
        vm.due = res;
        checkoutIsSubmitted = false;

        // if discount is applied add it to the order
        if (res.appliedCoupon) {
          vm.order.discountCoupon = res.appliedCoupon.id;
        }

        vm.cancellation = {
          policy: res.shopData.cancellationPolicy,
          isCustomCancellation: vm.info.isCustomCancellation,
          customCancellationText: vm.info.customCancellationText,
          milestones: res.shopData.cancellationMilestones,
          policyText: _.find(info.shop.CANCELLATION_POLICY, function (val) {
            return val[0] === res.shopData.cancellationPolicy;
          }),
          freeCancellationDays: vm.selectedTrip[0].freeCancellationDays,
          paymentTerms: res.shopData.paymentTerms,
          qty: 1,
          currency: vm.info.currency,
          onlyDP: function () {
            return false;
          },
        };

        vm.due.dueNow = _.find(res.paymentMilestonesData, {
          isDueNow: true,
        });

        vm.due.paymentSchedule = _.filter(res.paymentMilestonesData, {
          isDueNow: false,
        });

        $location.search({
          productId: null,
        });

        vm.mandatorySurchargesTaxes = vm.mandatorySurchargesGrossPrice * (vm.due.taxPercent / 100);
        vm.mandatorySurchargesPrice = vm.mandatorySurchargesGrossPrice;

        vm.packagePrices = cabinPrice + vm.divesPrices;
        vm.packagePricesTaxes =  vm.packagePrices * (vm.due.taxPercent / 100);
        vm.selectedOptionsGrouped = _.map(_.groupBy(vm.selectedOptions, 'pricingId'));

        vm.itemsIncludedDiver = [];
        vm.itemsIncludedNonDiver = [];
        vm.itemsMandatory = [];
        vm.itemsExtra = [];

        vm.itemsMandatoryTotal = 0;
        vm.itemsExtraTotal = 0;
        vm.itemsExtraLegend = false;
        vm.itemsMandatoryLegend = false;


        _.each(vm.selectedOptionsGrouped, function (val) {
          val[0].totalPrice = 0;
          val[0].totalQty = 0;

          _.each(val, function (v) {
            val[0].totalPrice += +v.priceGross * v.qty;
            val[0].totalQty += v.qty;
          }, 0);
          if (val[0].isIncluded) {
            if (checkoutService.isDiverInclusionsLa(val[0])) {
              vm.itemsIncludedDiver.push(val[0]);
            } else {
              vm.itemsIncludedNonDiver.push(val[0]);
            }
          } else if (val[0].isMandatory) {
            vm.itemsMandatory.push(val[0]);

            if (val[0].payedInAdvance) {
              vm.itemsMandatoryTotal += val[0].totalPrice;
            } else {
              vm.itemsMandatoryLegend = true;
            }
          } else {
            vm.itemsExtra.push(val[0]);

            if (val[0].payedInAdvance || val[0].isInsurance) {
              vm.itemsExtraTotal += val[0].totalPrice;
            } else {
              vm.itemsExtraLegend = true;
            }
          }
        });

        vm.step = 4;

        var cartPrice = $rootScope.setValue(+res.amountTotal, vm.info.currency, true, 'USD');

        GTM.variables({
          checkout_order_amount: cartPrice,
          checkout_cart_value: cartPrice,
        });

        GTM.products('checkout_step_review', {
          checkout: {
            actionField: {
              step: 'Review',
            },
            products: gtmProducts,
          },
        });

        // last minute bookings;
        // show payment form only if trip starts earlier than 21 days from today

        if (utils.isLastMinuteBooking(vm.order.from)) {
          vm.showPaymentForm = true;
          vm.isLastMinute = true;
          if (vm.paymentProcessor === paymentService.STRIPE_PP) {
            paymentService.initStripe();
          } else if (vm.paymentProcessor === paymentService.ADYEN_PP) {
            paymentService.initAdyen();
          }
        } else {
          if (vm.experimentIsActive) {
            paymentService.initStripe();
          }
          vm.showPaymentForm = false;
          vm.isLastMinute = false;
        }

        vm.loader = false;

        if (scrollTarget) {
          $rootScope.scrollTo(scrollTarget);
        } else {
          $rootScope.scrollTo('.progress-bar');
        }
      }).catch(function () {
        vm.loader = false;
      });
    }

    function addInclusions() {
      vm.order.cabinPrice = _.clone(cabinPrice);
      vm.order.priceForPackage = 0;
      vm.divesPrices = 0;
      vm.mandatorySurchargesPrice = 0;
      vm.mandatorySurchargesGrossPrice = 0;
      vm.mandatoryItemsPrice = 0;
      vm.addedInclusions = [];
      vm.selectedOptions = [];
      vm.mandatorySurcharges = [];
      vm.transfers = [];
      vm.selectedRental = [];
      vm.selectedExtras = [];
      vm.selectedInclusions = [];

      _.each(vm.diversNumber, function (diver) {
        diver.selectedCourses = [];

        _.each(vm.inclusions[vm.rentalEquipmentId], function (course) {
          addItems(course, 'rental', true);
        });
        _.each(vm.inclusions[vm.divingInclusionsId], function (course) {
          addItems(course, 'divingIncl', true);
        });
        _.each(vm.diverCoursesList, function (course) {
          addItems(course, 'courses');
        });

        function addItems(course, type, dcItems) {
          var diverCourse = diver[type] && diver[type][course.pricingId],
            qty = diverCourse && diverCourse.qty;

          if (qty) {
            var c = _.cloneDeep(course);
            c.qty = qty;
            c.isDiveCenterItem = dcItems;

            if (c.isIncluded) {
              c.price = 0;
              c.priceGross = 0;
            }

            if (type === 'courses') {
              c.isCourse = true;
            }

            diver.selectedCourses.push(c);
            vm.selectedOptions.push(c);

            if (c.payedInAdvance !== false && !c.isMandatory) {
              vm.order.cabinPrice += qty * c.priceGross;
            } else if (c.isMandatory && c.payedInAdvance !== false) {
              vm.mandatoryItemsPrice += qty * c.priceGross;
            }

            var obj = {
              diverNumber: diver.key,
              pricing: course.pricingId,
              description: course.description,
              quantity: qty,
            };

            vm.addedInclusions.push(obj);
          }
        }
      });

      _.each(vm.nonDiversNumber, function (nonDiver) {
        nonDiver.selectedCourses = [];
        _.each(vm.nonDiverCoursesList, function (course) {
          var qty = _.get(nonDiver, 'courses[' + course.pricingId + '].qty');
          if (qty) {
            var c = _.cloneDeep(course);
            c.qty = qty;
            if (c.payedInAdvance !== false && !c.isMandatory) {
              vm.order.cabinPrice += qty * +c.priceGross;
            } else if (c.isMandatory && c.payedInAdvance !== false) {
              vm.mandatoryItemsPrice += qty * +c.priceGross;
            }
            nonDiver.selectedCourses.push(c);
            vm.selectedOptions.push(c);

            var obj = {
              diverNumber: nonDiver.key,
              pricing: c.pricingId,
              description: c.description,
              quantity: qty,
            };

            vm.addedInclusions.push(obj);
          }
        });
      });

      _.each(vm.liveaboardInclusions, function (val) {
        _.each(val.data, function (v) {
          if (v.isIncluded || v.isMandatory) {
            v.qty = checkoutService.setLimit(v, {
              itinerary: vm.selectedTrip[0].itinerary && vm.selectedTrip[0].itinerary.slug,
              diversNumber: vm.diversNumber.length,
              nonDiversNumber: vm.nonDiversNumber.length,
              trip: vm.selectedTrip[0],
              cabinsNumber: vm.groupedCart.length,
            });
          }

          if (v.qty) {
            // var price = v.qty * v.price;
            if (v.isIncluded) {
              v.price = 0;
              v.priceGross = 0;
            }

            if (utils.isBelongsTo(v.belongsTo, 'Transfers')) {
              v.isTransfer = true;
              vm.transfers.push(v);
            }

            if (v.payedInAdvance !== false && !v.isMandatory) {
              vm.order.cabinPrice += v.qty * v.priceGross;
            } else if (v.isMandatory && v.payedInAdvance !== false) {
              vm.mandatoryItemsPrice += v.qty * v.priceGross;
            }
            var additionalItem = {
              pricing: v.pricingId,
              description: v.description,
              quantity: v.qty,
            };
            vm.selectedOptions.push(v);
            vm.addedInclusions.push(additionalItem);

            vm.selectedInclusions.push(additionalItem);
          }
        });
      });

      _.each(vm.insurances, function (val) {
        if (val.qty) {
          var additionalItem = {
            pricing: val.prices[0].id,
            quantity: val.qty,
          };
          vm.addedInclusions.push(additionalItem);
          vm.selectedInclusions.push(additionalItem);

          var price = $rootScope.setValue(val.prices[0].priceConverted, val.prices[0].priceConvertedCurrency, true, vm.info.currency);
          vm.selectedOptions.push({
            title: val.title,
            qty: val.qty,
            priceGross: val.isFree ? 0 : price,
            isIncluded: val.isFree,
            currency: vm.info.currency,
            isInsurance: true,
          });


          if (!val.isFree) {
            vm.order.cabinPrice += val.qty * price;
          }
        }
      });
    }

    function addProduct(variant, type, cabin) {
      if (variant.disabled && type !== 'minus') {
        return false;
      }

      checkoutService.addProduct(variant, type, cabin, currentDO);

      disableOccupancy(variant, cabin);

      if (type === 'plus') {
        var facebookObject = {
          content_ids: [vm.info.id],
          content_type: 'product',
          value: 0,
          currency: vm.info.currency,
        };
        _.each(vm.cabins, function (v) {
          var prices = _.filter(v.prices, 'qty');

          _.each(prices, function (val) {
            facebookObject.value += val.priceNet;
          });
        });

        if (window.fbq) {
          window.fbq('track', 'AddToCart', facebookObject);
        }
      }
    }

    function disableOccupancy(variant, cabin) {
      if (!variant || !cabin) {
        return false;
      }
      var totalQty = _.sum(cabin.prices, 'qty');

      cabin.availability = cabin.itemAvailability - totalQty;


      _.each(cabin.prices, function (val) {
        val.disabled = totalQty >= cabin.itemAvailability;
      });
    }

    function calculatePrice(product, field, number, formattedNumber, getTaxesPrice) {
      var price = 0;

      if (!field) {
        field = 'priceNet';
      }

      _.each(product, function (val) {
        price += val[field] * val.qty;
      });

      if (getTaxesPrice && vm.due.taxPercent) {
        price *= vm.due.taxPercent / 100;
      }

      var result;

      if (formattedNumber) {
        result = $rootScope.setValue(price, vm.info.currency, false, false, false, true);
      } else {
        result = $rootScope.setValue(price, vm.info.currency, number);
      }

      return result;
    }

    function calculatePercent(product) {
      var saleQty = calculatePrice(product, false, true) / calculatePrice(product, 'compareAtPrice', true),
        sale = 100 - (saleQty * 100);

      if (sale < 10) {
        return +(Math.round(sale + 'e+2') + 'e-2');
      }

      return Math.round(sale);
    }

    /**
            This code is totally shitty. But I don't have any another idea how to impelement it in better way.
        **/

    function checkCabin(callback) {
      /**
               Create cart array, where we will place generated pricing objects.

               Correct structure of this array is:

               cart = [
                 [{ Cabin1 object }],  - it mean, that we have in room only Divers or Non-divers
                 [{ Cabin 2 object (Diver)}, Cabin 2 object (Non-diver)], - If we have in one room diver and non-diver I should display it
                                                                            in one Cabin and show to different prices.
                 etc...
               ]
            **/
      var cart = [];

      // Itirate diver array to find selected products on step 2
      _.each(vm.cabins, function (v) {
        // Filter products with qty > 0;
        var prices = _.filter(v.prices, 'qty'),
          cabin = [];
        // If we have at least one
        if (prices.length) {
          /*
                        qty - Total qty of selected products (Divers + Non Divers);
                        maxOccupancy - maximum occupancy of room
                        v.guestNumber - is setting up for step 3 to display correct number of guest in warning message for shared occupancy
                    */
          var qty = _.sum(prices, 'qty'),
            maxOccupancy = _.cloneDeep(v.roomCategory.maxOccupancy);
          v.guestNumber = qty;

          /*
                         If room have occupancy 1 - it can't be shared. Allways set it to Single occupancy
                    */
          if (maxOccupancy === 1) {
            // If we selected only Diver or Non-diver than prices length will be 1.
            if (prices.length === 1) {
              // Generate fake array, that have length = number of guest in that room, to iteration with number
              var array = new Array(qty);

              _.each(array, function () {
                // Clone that element, because we change qty number and if we did it without cloning it will change qty in parent object.
                var productObj = _.clone(_.find(v.prices, {
                  'numberOfInstances': 1,
                  'isDiver': prices[0].isDiver,
                  isShared: false,
                }));
                productObj.qty = 1;
                // Push product object to cabin
                cabin.push(productObj);
                // Push that cabin to our cart array;
                cart.push({
                  room: v,
                  pricing: cabin,
                });
                // Clear cabin
                cabin = [];
              });
            } else {
              // Here we have selected divers and non divers. Should find a quantity of selected divers and non divers and after that push it
              // like above.
              var divers = _.find(prices, {
                  'isDiver': true,
                }),
                nonDiver = _.find(prices, {
                  'isDiver': false,
                }),
                diverArray = new Array(divers.qty),
                nonDiverArray = new Array(nonDiver.qty);

              _.each(diverArray, function () {
                var productObj = _.clone(_.find(v.prices, {
                  'numberOfInstances': 1,
                  'isDiver': true,
                  isShared: false,
                }));
                productObj.qty = 1;

                cabin.push(productObj);

                cart.push({
                  room: v,
                  pricing: cabin,
                });

                cabin = [];
              });

              _.each(nonDiverArray, function () {
                var productObj = _.clone(_.find(v.prices, {
                  'numberOfInstances': 1,
                  'isDiver': false,
                  isShared: false,
                }));
                productObj.qty = 1;

                cabin.push(productObj);

                cart.push({
                  room: v,
                  pricing: cabin,
                });

                cabin = [];
              });
            }
          } else {
            /*
              If room have occupancy > 1 - it can be shared.
            */
            // prices.length == 1 - it mean that we selected diver or non-diver. Can't be diver and non-diver in one cart;
            if (prices.length === 1) {
              /*
                If guest number == 1 we will set shared room
              */
              if (qty === 1) {
                var productObj = _.clone(_.find(v.prices, {
                  'numberOfInstances': 1,
                  'isDiver': prices[0].isDiver,
                  isShared: v.isShared,
                }));
                productObj.qty = 1;

                cabin.push(productObj);

                /*
                                    Select room with number of instances equal max occupancy.
                                */
              } else if (qty === maxOccupancy) {
                var productObj = _.find(v.prices, {
                  'numberOfInstances': maxOccupancy,
                  'isDiver': prices[0].isDiver,
                });
                productObj.qty = maxOccupancy;


                cabin.push(productObj);
                /*
                                        If qty > or < maxOccupancy.
                                    */
              } else if (qty !== maxOccupancy) {
                var cabinsNumber = Math.ceil(qty / maxOccupancy),
                  array = new Array(cabinsNumber),
                  productQty = prices[0].qty;

                _.each(array, function () {
                  // productQty >= maxOccupancy - then we will select pricing with maxOccupancy of room
                  if (productQty >= maxOccupancy) {
                    var productObj = _.clone(_.find(v.prices, {
                      'numberOfInstances': maxOccupancy,
                      'isDiver': prices[0].isDiver,
                    }));
                    productObj.qty = maxOccupancy;

                    cabin.push(productObj);

                    cart.push({
                      room: v,
                      pricing: cabin,
                    });

                    cabin = [];


                    // Remove from ProductQty. To correct calculation on next steps.
                    productQty -= maxOccupancy;

                    // Add shared room. If we have only 1 guest.
                  } else if (productQty === 1 && productQty < maxOccupancy) {
                    var productObj = _.clone(_.find(v.prices, {
                      'numberOfInstances': 1,
                      'isDiver': prices[0].isDiver,
                      isShared: v.isShared,
                    }));
                    productObj.qty = productQty;

                    cabin.push(productObj);

                    cart.push({
                      room: v,
                      pricing: cabin,
                    });

                    cabin = [];

                    productQty -= maxOccupancy;
                    // If productQty > 1 and < maxOccupancy - we will add pricing where number of instance is equal number of guests.
                  } else if (productQty > 1 && productQty < maxOccupancy) {
                    var productObj = _.clone(_.find(v.prices, {
                      'numberOfInstances': productQty,
                      'isDiver': prices[0].isDiver,
                    }));
                    productObj.qty = productQty;

                    cabin.push(productObj);

                    cart.push({
                      room: v,
                      pricing: cabin,
                    });

                    cabin = [];

                    productQty -= maxOccupancy;
                  }
                });
              }
            } else {
              // If we have diver and non diver


              if (qty === maxOccupancy) {
                _.each(prices, function (pr) {
                  var productObj = _.find(v.prices, {
                    'numberOfInstances': maxOccupancy,
                    'isDiver': pr.isDiver,
                  });
                  productObj.qty = pr.qty;

                  cabin.push(productObj);
                });
              } else if (qty !== maxOccupancy) {
                var cabinsNumber = Math.ceil(qty / maxOccupancy),
                  array = new Array(cabinsNumber),
                  divers = _.find(prices, {
                    'isDiver': true,
                  }),
                  nonDiver = _.find(prices, {
                    'isDiver': false,
                  }),
                  diversQty = divers.qty,
                  nonDiverQty = nonDiver.qty,
                  totalPeople = diversQty + nonDiverQty;

                if (totalPeople % maxOccupancy === 1) {
                  $scope.totalPeople = totalPeople;
                  $scope.roomTitle = v.roomCategory.title;

                  var modalInstance = $uibModal.open({
                    animation: false,
                    templateUrl: '../templates/_form-select-la-type.html',
                    controller: 'ModalCtrl',
                    controllerAs: 'ctrl',
                    backdrop: 'static',
                    keyboard: false,
                    scope: $scope,
                  });

                  return modalInstance.result.then(function (res) {
                    cabin = selectUserType({
                      array: array,
                      v: v,
                      cabin: cabin,
                      maxOccupancy: maxOccupancy,
                      diversQty: diversQty,
                      nonDiverQty: nonDiverQty,
                      cart: cart,
                      isDiver: true,
                    });
                  }, function (err) {
                    cabin = selectUserType({
                      array: array,
                      v: v,
                      cabin: cabin,
                      maxOccupancy: maxOccupancy,
                      diversQty: diversQty,
                      nonDiverQty: nonDiverQty,
                      cart: cart,
                      isDiver: false,
                    });
                  }).finally(function () {
                    if (cabin.length) {
                      cart.push({
                        room: v,
                        'pricing': cabin,
                      });
                    }

                    vm.groupedCart = cart;
                    selectedCabins.concat(cart);

                    if (callback) {
                      callback();
                    }

                    return selectedCabins;
                  });
                }
                cabin = selectUserType({
                  array: array,
                  v: v,
                  cabin: cabin,
                  maxOccupancy: maxOccupancy,
                  diversQty: diversQty,
                  nonDiverQty: nonDiverQty,
                  cart: cart,
                  isDiver: false,
                });
              }
            }
          }
        }

        if (cabin.length) {
          cart.push({
            room: v,
            'pricing': cabin,
          });
        }
      });

      vm.groupedCart = cart;

      return cart;
    }

    function haveSharedRooms() {
      var shared = false;
      _.each(vm.groupedCart, function (val) {
        if (_.find(val.pricing, {
          isShared: true,
        })) {
          shared = true;
        }
      });

      return shared;
    }

    function clearCart() {
      // vm.paymentType = null;
      paymentService.destroyElements();
      _.each(vm.cabins, function (val) {
        _.each(val.prices, function (v) {
          v.qty = 0;
          v.disabled = false;
        });
      });
    }

    function updateInsurances(price) {
      vm.paidInsurances = false;
      _.each(vm.insurances, function (insurance) {
        insurance.isFree = $rootScope.setValue(price, vm.info.currency, true, insurance.limitPriceCurrency) > +insurance.limitPrice;
        if (!insurance.isFree) {
          // show insurance only if its free;
          insurance.qty = 0;
          vm.paidInsurances = true;
        }
      });
    }

    function updateShared(cabin, returnPrice, shared) {
      var singleOccupancy;

      if (!shared) {
        shared = false;
      }

      _.each(vm.cabins, function (val) {
        if (val.roomCategory.id === cabin.room.roomCategory.id) {
          _.each(val.prices, function (v) {
            if (v.isShared == shared && v.numberOfInstances === 1 && v.isDiver === cabin.pricing[0].isDiver) {
              singleOccupancy = v;
              singleOccupancy.qty = cabin.pricing[0].qty;
              singleOccupancy.upgraded = !shared;
            }
          });
        }
      });

      if (returnPrice) {
        return singleOccupancy.priceNet;
      }

      cabin.pricing[0] = singleOccupancy;
      checkProducts(vm.groupedProducts);
    }

    function updateRoom(cabin, maxOccupancy) {
      var clonedCabins = _.clone(vm.cabinsObj);

      _.each(clonedCabins, function (val) {
        if (val.roomCategory.id === cabin[0].roomId) {
          _.each(val.prices, function (v) {
            _.each(cabin, function (cab) {
              if (v.numberOfInstances == maxOccupancy && !v.isShared && v.isDiver === cab.isDiver) {
                v.qty = cab.qty;
              } else if (v.numberOfInstances != maxOccupancy || v.isShared) {
                v.qty = 0;
              }
            });
          });
        }
      });

      vm.cabins = clonedCabins;
      checkProducts();
    }


    function selectUserType(data) {
      var array = data.array,
        v = data.v,
        cabin = data.cabin,
        maxOccupancy = data.maxOccupancy,
        diversQty = data.isDiver ? data.diversQty : data.nonDiverQty,
        nonDiverQty = data.isDiver ? data.nonDiverQty : data.diversQty,
        cart = data.cart,
        isDiverUser = data.isDiver,
        diverPricing, nonDiverPricing;


      _.each(array, function () {
        if (nonDiverQty >= maxOccupancy) {
          diverPricing = _.clone(_.find(v.prices, {
            'numberOfInstances': maxOccupancy,
            'isDiver': !isDiverUser,
          }));

          diverPricing.qty = maxOccupancy;
          cabin.push(diverPricing);

          cart.push({
            room: v,
            pricing: cabin,
          });

          cabin = [];

          nonDiverQty -= maxOccupancy;
        } else if (nonDiverQty > 0 && nonDiverQty < maxOccupancy && diversQty && diversQty < maxOccupancy && diversQty + nonDiverQty <= maxOccupancy) {
          diverPricing = _.clone(_.find(v.prices, {
            'numberOfInstances': diversQty + nonDiverQty,
            'isDiver': true,
          }));
          nonDiverPricing = _.clone(_.find(v.prices, {
            'numberOfInstances': diversQty + nonDiverQty,
            'isDiver': false,
          }));
          nonDiverPricing.qty = diversQty;
          diverPricing.qty = nonDiverQty;

          cabin.push(diverPricing);
          cabin.push(nonDiverPricing);

          cart.push({
            room: v,
            pricing: cabin,
          });

          cabin = [];
          diversQty -= maxOccupancy;
          nonDiverQty -= maxOccupancy;
        } else if (diversQty + nonDiverQty < maxOccupancy && diversQty > 0 && nonDiverQty > 0) {
          nonDiverPricing = _.clone(_.find(v.prices, {
            'numberOfInstances': diversQty + nonDiverQty,
            'isDiver': false,
          }));
          diverPricing = _.clone(_.find(v.prices, {
            'numberOfInstances': diversQty + nonDiverQty,
            'isDiver': true,
          }));
          nonDiverPricing.qty = diversQty;
          diverPricing.qty = nonDiverQty;

          cabin.push(nonDiverPricing);
          cabin.push(diverPricing);

          cart.push({
            room: v,
            pricing: cabin,
          });

          cabin = [];

          diversQty -= diversQty + nonDiverQty;
          nonDiverQty -= diversQty + nonDiverQty;
        } else if (diversQty && nonDiverQty && diversQty + nonDiverQty > maxOccupancy && maxOccupancy > 2) {
          nonDiverPricing = _.clone(_.find(v.prices, {
            'numberOfInstances': maxOccupancy,
            'isDiver': false,
          }));
          diverPricing = _.clone(_.find(v.prices, {
            'numberOfInstances': maxOccupancy,
            'isDiver': true,
          }));
          nonDiverPricing.qty = maxOccupancy - nonDiverQty;
          diverPricing.qty = nonDiverQty;

          cabin.push(nonDiverPricing);
          cabin.push(diverPricing);

          cart.push({
            room: v,
            pricing: cabin,
          });

          cabin = [];

          diversQty -= maxOccupancy - nonDiverQty;
          nonDiverQty -= nonDiverQty;
        } else if (diversQty < maxOccupancy && diversQty > 1 && nonDiverQty < 1) {
          nonDiverPricing = _.clone(_.find(v.prices, {
            'numberOfInstances': diversQty,
            'isDiver': isDiverUser,
          }));
          nonDiverPricing.qty = diversQty;

          cabin.push(nonDiverPricing);

          cart.push({
            room: v,
            pricing: cabin,
          });

          cabin = [];

          diversQty -= maxOccupancy;
        } else if (diversQty >= maxOccupancy && nonDiverQty !== 1) {
          nonDiverPricing = _.clone(_.find(v.prices, {
            'numberOfInstances': maxOccupancy,
            'isDiver': isDiverUser,
          }));
          nonDiverPricing.qty = maxOccupancy;

          cabin.push(nonDiverPricing);

          cart.push({
            room: v,
            pricing: cabin,
          });

          cabin = [];

          diversQty -= maxOccupancy;
        } else if (diversQty >= maxOccupancy && nonDiverQty === 1) {
          nonDiverPricing = _.clone(_.find(v.prices, {
            'numberOfInstances': maxOccupancy,
            'isDiver': false,
          }));
          diverPricing = _.clone(_.find(v.prices, {
            'numberOfInstances': maxOccupancy,
            'isDiver': true,
          }));
          nonDiverPricing.qty = maxOccupancy - 1;
          diverPricing.qty = 1;

          cabin.push(diverPricing);
          cabin.push(nonDiverPricing);

          cart.push({
            room: v,
            pricing: cabin,
          });

          cabin = [];

          diversQty -= maxOccupancy - 1;
          nonDiverQty -= 1;
        } else if (nonDiverQty === 1 && diversQty < 1) {
          diverPricing = _.clone(_.find(v.prices, {
            'numberOfInstances': 1,
            'isDiver': !isDiverUser,
            'isShared': v.isShared,
          }));
          diverPricing.qty = 1;

          cabin.push(diverPricing);

          cart.push({
            room: v,
            pricing: cabin,
          });

          cabin = [];

          nonDiverQty -= 1;
        } else if (diversQty === 1 && nonDiverQty < 1) {
          nonDiverPricing = _.clone(_.find(v.prices, {
            'numberOfInstances': 1,
            'isDiver': isDiverUser,
            'isShared': v.isShared,
          }));
          nonDiverPricing.qty = 1;

          cabin.push(nonDiverPricing);

          cart.push({
            room: v,
            pricing: cabin,
          });

          cabin = [];

          diversQty -= 1;
        }
      });

      return cabin;
    }

    function setStaffOrder() {
      vm.order.shop = vm.info.id;
      vm.order.cart = vm.groupedCart;
      vm.order.items = [].concat(vm.addedInclusions);
      vm.order.dateTo = vm.order.to;
      vm.order.dateFrom = vm.order.from;

      if (affiliate && Auth.isAffiliate()) {
        vm.order.affiliateId = affiliate.aid;
        vm.order.affiliateCampaign = affiliate.cid;
      }

      _.each(vm.order.cart, function (v) {
        _.each(v.pricing, function (val) {
          vm.order.items.push({
            pricing: val.id,
            quantity: val.qty,
          });
        });
      });
    }

    function createAccount(form) {
      form.$setSubmitted();

      if (form.$valid) {
        vm.reg.password2 = vm.reg.password;
        vm.reg.firstName = vm.order.firstName;
        vm.reg.lastName = vm.order.lastName;
        vm.reg.email = vm.order.email;
        vm.reg.orderId = vm.orderId;

        $rootScope.oldState = false;
        Auth.registration(vm.reg).catch(function (error) {
          if (error) {
            $rootScope.showNotify(error[0]);
          }
        });
      }
    }


    function setUserAccount(account) {
      vm.order.account = account ? account.id : null;
      vm.userPaymentMethod = null;
      paymentService.getUserCC(account.id).then(function (data) {
        vm.userPaymentMethod = data;
      });
    }


    function setPageAfterCheckout(data) {
      if (Auth.isStaff()) {
        var link;

        if (utils.isDev) {
          link = 'https://intranet.diviac.inprogress.rocks/booking-list';
        } else {
          link = 'https://intranet.diviac.com/booking-list';
        }

        window.location.href = link + '?order_id=' + data.id + '&tab=Internal';
      } else {
        vm.step = 5;
        vm.loader = false;
      }
    }

    function stepChanged(step) {
      if (vm.step > step) {
        vm.step = step;

        onStepChange();
      }

      if (step < 4) {
        // vm.paymentType = null;
        paymentService.destroyElements();
      }
    }

    function onStepChange() {
      if (vm.step === 1 && !vm.trips) {
        vm.setFirstStep();
      }

      if (vm.step === 2 && !$rootScope.order) {
        vm.clearCart();
        vm.cabins = savedStepTwoCabins;
      }

      $timeout($rootScope.scrollTo('.progress-bar'), 250);
    }

    function getTotalPrice() {
      if (vm.due && vm.step === 4) {
        return vm.due.amountTotal;
      }
      return vm.order.cabinPrice || false;
    }

    function saveStepTwo() {
      selectedCabins = [];
      vm.order.items = [];
      vm.selectedOptions = [];
      vm.mandatorySurcharges = [];
      vm.transfers = [];
      vm.selectedRental = [];
      vm.selectedExtras = [];
      vm.selectedInclusions = [];

      savedStepTwoCabins = _.cloneDeep(vm.cabins);
      selectedCabins = checkCabin(getInclusions);

      if (selectedCabins && selectedCabins.length) {
        getInclusions();
      }
    }

    function applyVoucher() {
      if (vm.voucherCode && vm.voucherCode.length) {
        vm.loader = true;
        checkoutService.validateVoucher(vm.voucherCode).then(function (result) {
          vm.loader = false;
          vm.appliedVoucher = result;
          vm.voucherCode = '';
          vm.showCouponForm = false;
          checkProducts(false, '#discount-pan');
        }).catch(function (err) {
          vm.discountError = _.get(err.data, 'code[0]');
          vm.loader = false;
        });
      }
    }

    function removeVoucher() {
      vm.appliedVoucher = false;
      checkProducts(false, '#discount-pan');
      $rootScope.showNotify('Discount was removed');
    }
  });

angular.module('app')
  .controller('ModalCtrl', function ($scope, $uibModalInstance) {
    var vm = this;

    vm.continue = function () {
      if (!vm.diver) {
        return 1;
      }

      if (vm.diver === 'diver') {
        $uibModalInstance.close('close');
      } else {
        $uibModalInstance.dismiss('close');
      }
    };
  });
